import { render, staticRenderFns } from "./searchPerson.vue?vue&type=template&id=26c0ccdb&scoped=true&"
import script from "./searchPerson.vue?vue&type=script&lang=ts&"
export * from "./searchPerson.vue?vue&type=script&lang=ts&"
import style0 from "./searchPerson.vue?vue&type=style&index=0&id=26c0ccdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c0ccdb",
  null
  
)

export default component.exports